import { showProductsPerAvailableTypeModal } from '@/redux/slices/checkout.slice';
import { useAppDispatch, useAppSelector } from '@/redux';
import { CartProductModel } from '@/models';
import { ModalHeaderDsProps } from '@/components/layout/modals/ModalHeader.ds';
import { useTranslation } from 'next-i18next';
import { useAnimation } from '@/hooks';
import { ANIMATION } from '@/constants/animation';

export const useProductsPerAvailableType = () => {
  function hideProductsPerAvailableTypeModal() {
    handleCloseModal();
    setTimeout(() => {
      dispatch(showProductsPerAvailableTypeModal({
        shouldOpen: false, shippingId: '', shipmentNumber: '', orderBefore: '', deliveryFrom: ''
      }));
    }, ANIMATION.SHORT_DELAY);
  }

  function getProductsPerAvailableType() {
    return cartProducts
      .filter((cartProduct: CartProductModel) => cartProduct.product.item.attributes.in_stock.valueId === shippingId)
      .map((cartProduct: CartProductModel) => ({
        ...cartProduct.product, quantity: cartProduct.quantity
      }));
  }

  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const shippingId = useAppSelector(({ checkout }) => checkout.selectedDeliveryAvailableType);
  const cartProducts = useAppSelector(({ cart }) => cart.content.products);
  const productPerAvailableTypeModal = useAppSelector(({ checkout }) => checkout.productsPerAvailableTypeModal);
  const { animationState: animation, handleCloseModal } = useAnimation({});

  const headerProps = {
    onCloseClick: hideProductsPerAvailableTypeModal,
    title: `${t('checkout:cart.shipment')} ${productPerAvailableTypeModal.shipmentNumber}`,
  } satisfies ModalHeaderDsProps;

  return {
    hideProductsPerAvailableTypeModal,
    products: getProductsPerAvailableType(),
    productPerAvailableTypeModalIsOpened: productPerAvailableTypeModal.isOpen,
    orderBefore: productPerAvailableTypeModal.orderBefore,
    deliveryFrom: productPerAvailableTypeModal.deliveryFrom,
    headerProps,
    translate: t,
    shippingId,
    animation
  };
};
